import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataTableColumn } from 'src/app/shared/components';
import { IsLoading, LoadingWrapper } from 'src/app/shared/decorators';
import { SessionsWeeklySummaryDto } from 'src/app/shared/dto';
import { DashboardApiService } from 'src/app/shared/services/api';

const LOADER_SESSION_SUMMARY: string = 'session-summary'

@Component({
    selector: 'app-sessions-card-container',
    templateUrl: './sessions-card-container.component.html',
    styleUrls: ['../../common-reporting-dashboard.scss'],
    standalone: false
})
export class SessionsCardContainerComponent {
    @IsLoading(LOADER_SESSION_SUMMARY) isSessionSummaryLoading$: Observable<boolean>;

    isShowChart: boolean = true;

    sessionSummary$: Observable<SessionsWeeklySummaryDto[]>;

    constructor(private readonly dashboardApiService: DashboardApiService) {
        this.sessionSummary$ = this.getSessionSummary().pipe(
            map(summaries => summaries.map(session => ({
                ...session,
                portalSessionCount: session.portalSessionCount || 0,
                revdriverSessionCount: session.revdriverSessionCount || 0,
                totalSessionCount: (session.portalSessionCount || 0) + (session.revdriverSessionCount || 0)
            })))
        );
    }

    @LoadingWrapper(LOADER_SESSION_SUMMARY)
    private getSessionSummary(): Observable<SessionsWeeklySummaryDto[]> {
        return this.dashboardApiService.getSessionSummary()
    }
}
